// from Interstate
export const getFilteredData = (
  data: any,
  filterBy: string | undefined,
  columns: any
): any[] => {
  if (!filterBy) {
    return data;
  }
  return data.filter((item: any) => {
    return columns.some((c: any) => {
      return c.dataIndex && item[c.dataIndex]
        ? item[c.dataIndex]
            .toString()
            .toLowerCase()
            .includes(filterBy.toLowerCase())
        : false;
    });
  });
};
